import { render, staticRenderFns } from "./SurveyBreadcrumbs.vue?vue&type=template&id=1897e737&scoped=true"
import script from "./SurveyBreadcrumbs.vue?vue&type=script&lang=js"
export * from "./SurveyBreadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1897e737",
  null
  
)

export default component.exports